import SelectCustom from '@design/objects/select-custom/twig/assets'
import ElementPropertiesManager from 'assets/core/js/module/element-properties-manager'
import type { SelectCustomConfig } from '@design/objects/select-custom/twig/assets'

export type { default as SelectCustom, SelectCustomConfig } from '@design/objects/select-custom/twig/assets'

export default (element: HTMLDetailsElement, config: SelectCustomConfig = {}): SelectCustom | undefined => {
  const selectEl = element.querySelector<HTMLSelectElement>('select')

  if (!selectEl || ElementPropertiesManager.hasProperty(selectEl, 'select')) {
    return
  }

  const selectCustom = new SelectCustom(element, config)

  ElementPropertiesManager.addProperty<typeof selectCustom>(selectEl, 'select', selectCustom)

  return selectCustom
}
